module.exports = __webpack_public_path__ + "fonts/fa-light-300.b33449667ce61388905a97b13f01ea16.woff2";